module.exports = __webpack_public_path__ + "img/flot3.df7d343a.svg";